import DynamicForm from "f1-dynamic-form-react";
import React, { useEffect, useState, useRef } from "react";
import { INMATE_ACCOUNT_FORM } from "../../pages/formData";
import Grid from "@mui/material/Grid";
import { useNavigate } from "react-router-dom";
import { getAllOfTable, removeCollection } from "../../offlineManager/localbase";
import ModalPopup from "f1-modal-react";
import { Button } from "@material-ui/core";
import { metaDataConstants } from "../../utils/Constants/constants-en";
import { getDateWithFormat } from "../../utils/utils";
import moment from "moment"


const InmateScanForm = () => {
    let dyFormRef = useRef();
    let naviagte = useNavigate();

    
    const [accountForm, setAccountForm] = useState(INMATE_ACCOUNT_FORM)
    const [showModal, setShowModal] = useState(false);
    const [disableSubmit, setDisableSubmit] = useState(true)
    let disable = true
    const [selectedAccId, setSelectedAccId] = useState(-1)
    const [selectedLocId, setSelectedLocId] = useState(-1)
    const [selectedMealId, setSelectedMealId] = useState(-1)
    const [current, setCurrent] = useState({
        account: '-1',
        location: '-1',
        meal: -'1',
        mealDate: getDateWithFormat(metaDataConstants.yearMonthDateFormat)
    });
    
    useEffect(() => {
        getAccounts()
    }, [])
    
    useEffect(() => {
        disableSubmitButton()
    }, [current])

    const getAccounts = async () => {
        let accountsDetails = await getAllOfTable('AccountDetails')
        if (accountsDetails[0].accountDetails) {
            let accForm = [...accountForm]
            accForm[0].options = getDropdownData(
                accountsDetails[0].accountDetails,
                "id",
                "accountName"
            );
            setAccountForm(accForm);
        }
    }

    const getLocations = async (accountId) => {
        let res = await getAllOfTable('LocationDetails')
        if (res[0].locationDetails) {
            const loc = res[0].locationDetails?.filter(
                (ele) =>
                    ele.accountId == accountId
            );
            let accForm = [...accountForm]
            accForm[1].options = getDropdownData(
                loc,
                "id",
                "locationName"
            );
            setAccountForm(accForm);
        }
        if(accountId == '-1'){
            setSelectedLocId('-1')
            getMealPeriod(accountId, '-1')
        }
    }

    const getMealPeriod = async (accountId, locationId) => {
        let res = await getAllOfTable('MealPeriodDetails')
        if (res[0].mealPeriodDetails) {
            const loc = res[0].mealPeriodDetails?.filter(
                (ele) => {
                     /* 
                     Check valid meal period for current date
                     also valid time of that meal period
                     */                 
                    const startDate = ele.admissionStartDate?.split('T')?.[0]
                    const endDate = ele.admissionEndDate?.split("T")?.[0]
                    // checking meal period is valid for current date we are geting
                    const isValidDate = moment(moment()).isSameOrAfter(startDate) && moment(moment()).isSameOrBefore(endDate)
                    if (ele.accountId == accountId && ele.locationId == locationId && isValidDate) {
                        const { endHrsTime, endMinsTime, endTimeFormat } = ele
                        // current meal period is valid for that time range
                        const servePeriodEndTime = `${endHrsTime}:${endMinsTime} ${endTimeFormat}`
                        const tempServeTimeCompare = moment(servePeriodEndTime, ["hh:mm A"])
                        const currentTempTimeCompare = moment(moment().format("hh:mm A"), ["hh:mm A"]);
                        // added console log for see valid meal period for current time range 
                        if(currentTempTimeCompare.isBefore(tempServeTimeCompare)){
                            console.log(`id=${ele.id}`,startDate,endDate,servePeriodEndTime,moment().format("hh:mm A"))
                        }
                        return currentTempTimeCompare.isBefore(tempServeTimeCompare);
                    }
                }
            );
            let accForm = [...accountForm]
            accForm[2].options = getDropdownData(
                loc,
                "id",
                "mealPeriodName"
            );
            setAccountForm(accForm);
        }
        if(locationId == '-1'){
            setSelectedMealId('-1')
        }
    }

    const getDropdownData = (optionsArr, key, label) => {
        const arr = optionsArr?.map((item) => {
            return {
                key: item[key],
                label: item[label]?.charAt(0)?.toUpperCase() + item[label]?.slice(1),
                value: item[key],
            };
        });
        arr.unshift({ key: -1, label: "Select", value: -1 });
        return arr;
    };

    const onChangeHandler = async (event, key) => {
        const prevAccId = localStorage.getItem("accountId");
        const prevLocId = localStorage.getItem("locationId");
        const prevMeal = JSON.parse(localStorage.getItem("mealType"));
        const inmatesRecord = await getAllOfTable("Inmates");
        const tempVal = event.target.value;

        if (key === "account") {
            if (prevAccId != tempVal && inmatesRecord.length > 0) {
                setShowModal(true)
            } else {
                localStorage.setItem("accountId", tempVal);
                setSelectedAccId(tempVal)
                if(tempVal == '-1') {
                    setCurrent({
                        ...current,
                        account: tempVal,
                        location: tempVal,
                        meal: tempVal
                    })
                } else {
                    setCurrent({
                        ...current,
                        account: tempVal,
                        location: '-1',
                        meal: '-1'
                    })
                }
                getLocations(tempVal)
            }
        } else if (key === "location") {
            if (prevLocId != tempVal && inmatesRecord.length > 0) {
                setShowModal(true)
            } else {
                localStorage.setItem("locationId", tempVal);
                setSelectedLocId(tempVal)
                if(tempVal == '-1') {
                    setCurrent({
                        ...current,
                        location: tempVal,
                        meal: tempVal
                    })
                } else {
                    setCurrent({
                        ...current,
                        location: tempVal,
                        meal: '-1'
                    })
                }
                getMealPeriod(selectedAccId, tempVal)
            }
        } else if (key === "meal") {
            let localMeal;
            if (prevMeal?.key != tempVal && inmatesRecord.length > 0) {
                setShowModal(true);
            } else {
                accountForm[2].options.forEach(item => {
                    if (item.value == tempVal) {
                        localMeal = item
                    }
                })
                setSelectedMealId(tempVal)
                localStorage.setItem("mealType", JSON.stringify(localMeal));
                setCurrent({
                    ...current,
                    meal: tempVal
                })
            }
        }
        // disableSubmitButton()
    }

    const onSubmit = (model, flag) => {
        if (flag){
            naviagte('/inmate_scan_grid')
        } else {
            if (model.isValidForm) {
                naviagte('/inmate_scan_grid');
            }
        }
    }

    const onDiscard = () => {
        removeCollection("Inmates");
        setShowModal(false)
        window.location.reload();
    }

    const disableSubmitButton = () => {
        if (current.meal != '-1'&& current.location != '-1' && current.account != '-1'){
            setDisableSubmit(false)
            // disable = false
            return
        }
        setDisableSubmit(true)
    }

    return (
        <div className="container containerMainDiv">
            <div className="contentdivBg pt-0">
                <div className="divRound pt-4">
                    <div className="clearfix"></div>
                    <ModalPopup
                        show={showModal}
                        onHide={() => setShowModal(false)}
                        size={"sm"}
                        centered={true}
                        modelHeader={metaDataConstants.dataFromPrevScanPresent}
                        modelContent={

                            <div className="footerButtons">
                                <p>{metaDataConstants.submitOrDiscard}</p>
                                <Button
                                    className="btn-black btn Ripple-parent btn btn-primary"
                                    onClick={(model) => onSubmit(model, 1)}
                                >
                                    {metaDataConstants.submit}
                                </Button>
                                &nbsp;
                                <Button
                                    className="cancelBtn btn Ripple-parent btn btn-primary"
                                    onClick={onDiscard}
                                >
                                    {metaDataConstants.discard}
                                </Button>
                            </div>

                        }
                        backdrop={"static"}
                    />
                    <div className="formData mt-3">
                        <Grid
                            className="activiPad0"
                            container
                            columns={{ xs: 4, md: 12 }}
                        >
                            <Grid item xs={12} md={9} className="leftCol">
                                <DynamicForm
                                    onRef={(ref) => {
                                        dyFormRef.current = ref;
                                    }}
                                    key={1}
                                    className="dynamicForm"
                                    title={metaDataConstants.inmateForm}
                                    design="bootrstap"
                                    buttonSubmit={metaDataConstants.submit}
                                    model={accountForm}
                                    defaultValues={current}
                                    materialOutline={false}
                                    showAstersikOnRequiredFields={true}
                                    disableSubmitOnInValid={disableSubmit}
                                    onSubmit={(model) => onSubmit(model)}
                                    onChange={(event, key, model) =>
                                        onChangeHandler(event, key, model)
                                    }
                                />
                            </Grid>
                        </Grid>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default InmateScanForm;